<div #fullscreenContainer class="web-browser" [class.is-fullscreen]="isFullscreen">
  <div class="row position-relative pb-2">
    <spinner class="spinner w-100"></spinner>
  </div>
  <div class="position-relative h-100 book-area">
    <div #bookContainer id="bookContainer" class="book-container h-100 w-100">
      <div #contentContainer id="contentContainer" class="w-100 h-100 shadow overflow-auto"
         [innerHTML]="ebookContent"
         [ngStyle]="getZoom()"
         [ngClass]="getVariant()"
      ></div>
    </div>

  </div>

  <div class="control-bar shadow mt-3">
      <div class="my-2">
        <app-icon
          (click)="moveToPreviousPage()"
          class="lg-icon"
          name="arrow-back"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.PREVIOUS_PAGE' | translate"
        ></app-icon>
      </div>
      <div class="my-2">
        <app-icon
          (click)="jumpToPageModal.show()"
          class="icon-blue"
          name="go-to-page"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.JUMP_TO_PAGE' | translate"
        ></app-icon>
      </div>
      <div class="my-2 d-none d-md-block position-relative">
        <app-icon
          (click)="showBookSizeSettings()"
          class="md-icon"
          name="font-size"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.TEXT_SIZE' | translate"
        ></app-icon>
        <ng-container *ngIf="isBookSizeSettingsShown" class="position-absolute ">
            <div class="font-size-menu rounded-pill shadow px-3 py-2 d-flex flex-row justify-content-between">
            <app-icon
              class="me-3"
              name="text-decrease"
              (click)="changeTextSize(-1)"
            ></app-icon>
            <app-icon
              name="text-increase"
              (click)="changeTextSize(1)"
            ></app-icon>
        </div>
        </ng-container>
      </div>
      <div class="my-2">
        <app-icon
          (click)="toggleFullscreen()"
          class="md-icon"
          name="fullscreen"
          data-bs-toggle="tooltip" data-bs-placement="top"
          [title]="(isFullscreen ? 'EBOOKS.EXIT_FULLSCREEN' : 'EBOOKS.FULLSCREEN') | translate"
        ></app-icon>
      </div>
      <div class="my-2">
        <app-icon
          (click)="moveToNextPage()"
          class="lg-icon"
          id="buttonNext"
          name="arrow-next"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.NEXT_PAGE' | translate"
        ></app-icon>
      </div>
  </div>

  <app-modal #jumpToPageModal >
    <form #form="ngForm" class="jump-to-page modal-content" (submit)="jumpToPage()">
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn-close"
          (click)="jumpToPageModal.hide()"
          aria-label="Close"
        ></button>
      </div>
      <div>
        <span class="mb-2 me-2">{{ "EBOOKS.JUMP_TO_PAGE" | translate }}</span>
        <label>[{{firstPage}} - {{lastPage}}]</label>
        <input
          [(ngModel)]="pageSelection"
          [ngModelOptions]="{standalone: true}"
          class="page-input form-control my-2"
          type="number"
          required
          #pageSelectionInput="ngModel"
          [min]="firstPage"
          [max]="lastPage"
          />
        <div class="text-danger" *ngIf="pageSelectionInput.invalid && pageSelectionInput.touched">
          {{ "EBOOKS.RANGE_ERROR" | translate}} {{firstPage}} - {{lastPage}}.
        </div>
      </div>
      <div class="d-flex justify-content-end ">
        <button class="btn btn-primary rounded-pill" [disabled]="pageSelectionInput.invalid" (click)="jumpToPage()">
          {{ "EBOOKS.GO_TO_PAGE" | translate }}
        </button>
      </div>
    </form>
  </app-modal>
</div>
